import { Navigate } from 'react-router-dom';
import Cookies from 'js-cookie';

export const ProtectedRoute = ({ children }) => {
  const token = Cookies.get('auth_token');

  if (!token) {
    return <Navigate to="/" replace />;
  }

  return children;
};